
<div class="loader" [hidden]="status != LOADING">
    <div class="dimmed">
        <div class="dimmed_title"></div>
    </div>
</div>
<div *ngIf="status == DONE">
    <ul class="version-related-item">
        <li *ngFor="let version of versions" >
            <core-version-details-main
              [version]="version"
             ></core-version-details-main>
        </li>
    </ul>
</div>
